import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusSquare as farMinusSquare,
  faPlusSquare as farPlusSquare,
  faQuestionCircle as farQuestionCircle
} from "@fortawesome/free-regular-svg-icons";
import {
  ListGroup,
  Button,
  Container,
  Row,
  Col,
  Popover,
  Stack,
  Overlay
} from "react-bootstrap";
import { useNavigate, createSearchParams } from "react-router-dom";
import "./TreeItem.scss";
import { faShoppingCart, faPhoneSquareAlt } from "@fortawesome/free-solid-svg-icons";
import { useLang } from "../../common/hooks/useLang";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NAMESPACE_REMOTE } from "../../common/translations/TranslationHelper";

export function TreeItem({
  level = 0,
  hasNodes,
  isOpen,
  label,
  searchTerm,
  openNodes,
  toggleNode,
  matchSearch,
  focused,
  handleAddClosePopupFunctionToQueue,
  handleCloseAllPopups,
  ...props
}) {
  const { currentLanguage } = useLang();

  const ToggleIcon = ({ on }) => (
    <span>
      <FontAwesomeIcon
        icon={on ? farMinusSquare : farPlusSquare}
        className="me-2"
        size="1x"
      />
    </span>
  );

  const popover = (headerText, bodyText) => {
    return (
      <Popover id="popover-basic">
        <Popover.Header as="h3">{headerText}</Popover.Header>
        <Popover.Body style={{ whiteSpace: "pre-line" }}>{bodyText}</Popover.Body>
      </Popover>
    );
  };

  const containerRef = useRef(null);

  const [showContactInfo, setShowContactInfo] = useState(false);
  const buttonContactInfoRef = useRef(null);

  const handleContactInfoClicked = (e) => {
    if (!showContactInfo) {
      handleCloseAllPopups();
      handleAddClosePopupFunctionToQueue(handleHideContactInfo);
    }
    setShowContactInfo(!showContactInfo);
    // Do not expand tree on click
    e.stopPropagation();
  };

  const handleHideContactInfo = (e) => {
    setShowContactInfo(false);
  };

  const [showProductInfo, setShowProductInfo] = useState(false);
  const buttonProductInfoRef = useRef(null);

  const handleProductInfoClicked = (e) => {
    if (!showProductInfo) {
      handleCloseAllPopups();
      handleAddClosePopupFunctionToQueue(handleHideProductInfo);
    }
    setShowProductInfo(!showProductInfo);
    // Do not expand tree on click
    e.stopPropagation();
  };

  const handleHideProductInfo = (e) => {
    setShowProductInfo(false);
  };

  const navigate = useNavigate();
  const handleChooseItemClicked = (props) => {
    const searchParams = createSearchParams({
      id: props.pstaid,
    });
    navigate({
      pathname: "/order",
      search: `?${searchParams}`
    }, { replace: true });
  };

  const { t } = useTranslation(NAMESPACE_REMOTE);

  return (
    <ListGroup.Item
      {...props}
      style={{
        paddingLeft: 32 + (level - 1) * 30,
        cursor: "pointer",
        position: "relative",
      }}
      onClick={(e) => {
        if (props.standardorders) {
          handleChooseItemClicked(props);
        } else {
          hasNodes && toggleNode && toggleNode();
        }
      }}
    >
      <Container className="p-0 mx-0">
        <Row>
          <Col xs={1} sm={1}>
            {hasNodes && (
              <div style={{ display: "inline-block" }}>
                <ToggleIcon on={isOpen} />
              </div>
            )}
          </Col>

          <Col xs={7} sm={8} md={9} lg={10}>
            {currentLanguage === "en" ? props.labelenglish : label}
          </Col>

          <Col xs={4} sm={3} md={2} lg={1} className="text-end pe-0">
            <Stack direction="horizontal" className="justify-content-end">
              {props.contactinfo && (
                <Stack direction="horizontal" ref={containerRef}>
                  <Button 
                    variant="primary"
                    className="text-white py-0 me-2"
                    ref={buttonContactInfoRef}
                    onClick={handleContactInfoClicked}>
                      <FontAwesomeIcon icon={faPhoneSquareAlt} />
                  </Button>
                  <Overlay
                    show={showContactInfo}
                    target={buttonContactInfoRef.current}
                    container={containerRef}
                    placement="left"
                    containerPadding={20}
                    rootClose={true}
                    onHide={handleHideContactInfo}>
                    {popover(
                      t("TEXT.WSHOP2.PRODUCTS.CONTACT_INFORMATION"),
                      currentLanguage === "en" ? props.contactinfoenglish : props.contactinfo
                    )}
                  </Overlay>
                </Stack>
              )}

              {props.productinfo && (
                <Stack direction="horizontal" ref={containerRef}>
                  <Button 
                    variant="primary"
                    className="text-white py-0 me-2"
                    ref={buttonProductInfoRef}
                    onClick={handleProductInfoClicked}>
                      <FontAwesomeIcon icon={farQuestionCircle} />
                  </Button>
                  <Overlay
                    show={showProductInfo}
                    target={buttonProductInfoRef.current}
                    container={containerRef}
                    placement="left"
                    containerPadding={20}
                    rootClose={true}
                    onHide={handleHideProductInfo}>
                    {popover(
                      t("TEXT.WSHOP2.PRODUCTS.PRODUCT_INFORMATION"),
                      currentLanguage === "en" ? props.productinfoenglish : props.productinfo
                    )}
                  </Overlay>
                </Stack>
              )}

              {props.standardorders && (
                <Button
                  variant="primary"
                  className="text-white py-0 me-2"
                  onClick={() => handleChooseItemClicked(props)}>
                    <FontAwesomeIcon icon={faShoppingCart} />
                </Button>
              )}
            </Stack>
          </Col>
        </Row>
      </Container>
    </ListGroup.Item>
  );
}
